import Layout from '../../internal/Layout.vue'
import MyTasksPage from './MyTasks.vue'

const MyTasksRoutes = {
  component: Layout,
  children: [
    {
      name: 'myTasks',
      path: '/',
      component: MyTasksPage,
      meta: {
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
  ],
}

export default MyTasksRoutes
